import httpClient from "./auth-http-client";

const getUser = async () => {
    try {
        const response = await httpClient.get(`/user/me`);
        if (response.status === 200) {
            return response.data
        }
        return {}
    } catch (error) {
        console.error("Error:", error);
    }
};

const useSubmitInviteCode = async (code: number) => {
    try {
        const response = await httpClient.get(`/user/me/invite/${code}`);
        if (response.status === 200) {
            return response.data
        }
        return {}
    } catch (error) {
        console.error("Error:", error);
    }
};

const completeOnboarding = async () => {
    try {
        const response = await httpClient.post(`/user/onboarded`);
        if (response.status === 200) {
            return response.data
        }
        return {}
    } catch (error) {
        console.error("Error:", error);
    }
};

const syncPodioData = async () => {
    try {
        const response = await httpClient.post(`/user/sync-podio-data`);
        if (response.status === 200) {
            return response.data
        }
        return {}
    } catch (error) {
        console.error("Error:", error);
    }
};

const getAllUsers = async () => {
    try {
        const response = await httpClient.get(`/user/all`);
        if (response.status === 200) {
            return response.data
        }
        return []
    } catch (error) {
        console.error("Error:", error);
        return []
    }
};

const getAllCreators = async () => {
    try {
        const response = await httpClient.get(`/user/all-creators`);
        if (response.status === 200) {
            return response.data
        }
        return []
    } catch (error) {
        console.error("Error:", error);
        return []
    }
};

const inviteCreator = async (creatorId: string) => {
    try {
        const response = await httpClient.post(`/user/invite`, { creator_id: creatorId });
        if (response.status === 200) {
            return response.data
        }
        return {}
    } catch (error) {
        console.error("Error:", error);
        throw error;
    }
};

const getNotificationPreferences = async () => {
    try {
        const response = await httpClient.get(`/user/notification-preferences`);
        if (response.status === 200) {
            return response.data.preferences || {}
        }
        return {}
    } catch (error) {
        console.error("Error:", error);
        return {}
    }
};

const updateNotificationPreferences = async (preferences: Record<string, { push: boolean; email: boolean }>) => {
    try {
        const response = await httpClient.post(`/user/notification-preferences`, { preferences });
        if (response.status === 200) {
            return response.data
        }
        return {}
    } catch (error) {
        console.error("Error:", error);
        throw error;
    }
};

const checkPushSubscription = async () => {
    try {
        const response = await httpClient.get(`/notifications/has-push-subscription`);
        if (response.status === 200) {
            return response.data.has_subscription || false
        }
        return false
    } catch (error) {
        console.error("Error:", error);
        return false
    }
};

export {
    getUser,
    completeOnboarding,
    useSubmitInviteCode,
    syncPodioData,
    getAllUsers,
    getAllCreators,
    inviteCreator,
    getNotificationPreferences,
    updateNotificationPreferences,
    checkPushSubscription
}